import React, { useState } from 'react'
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
import { EditIcon, LinkIcon, TrashIcon } from '../../../../components/Icons'
import {
  DeleteConfirmationDialog,
  EditChatTitleDialog,
} from '../../../../components/shared/Dialogs'
import { useCopyToClipboard } from '../../../../hooks'
import { useSnackbar } from '../../../../components/SnackbarProvider'
import baseUrl, { domain } from '../../../../config/baseUrl'

interface Props {
  historyId: any
  threadId: any
  title: any
}

const Actions = ({ historyId, threadId, title }: Props) => {
  const [openDialog, setOpenDialog] = useState<{ editTitleDialog: boolean; deleteDialog: boolean }>(
    {
      editTitleDialog: false,
      deleteDialog: false,
    },
  )

  const userId = sessionStorage.getItem('userId')
  const showSnackbar = useSnackbar()
  const handleClick = (name: string) => (_event: React.MouseEvent<HTMLButtonElement>) => {
    setOpenDialog((prevState) => ({
      ...prevState,
      [name]: true,
    }))
  }

  const handleClose = (name: string) => {
    setOpenDialog((prevState) => ({
      ...prevState,
      [name]: false,
    }))
  }

  const [copyToClipboard] = useCopyToClipboard()
  const url = `${domain}/ShareChat/${threadId as string}`
  const handleShareClick = async () => {
    copyToClipboard(url)

    return false
  }

  const shareLink = async () => {
    try {
      const shareLinkRepsonse = await fetch(`${baseUrl}/api/sharechat/storesharechatnew`, {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          UserId: userId,
          ThreadId: threadId,
        }),
      })

      const shareLinkResponseData = await shareLinkRepsonse?.json()

      if (shareLinkRepsonse.ok) {
        showSnackbar(shareLinkResponseData?.message, 'success')
        sessionStorage.setItem('linkId', shareLinkResponseData?.data?.id)
      } else {
        showSnackbar(shareLinkResponseData?.message, 'error')
      }
    } catch (error: any) {
      // console.log('Error in shareLink api : ', error.message)
      showSnackbar(error?.message, 'error')
    }
  }

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const menuOpen = Boolean(anchorEl)

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      <IconButton
        size='small'
        sx={{ p: 0, color: 'common.gray' }}
        onClick={handleMenuOpen}
      >
        <MoreHorizIcon />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={menuOpen}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'center', horizontal: 'right' }}
        transformOrigin={{ vertical: 'center', horizontal: 'left' }}
        slotProps={{
          paper: {
            sx: {
              borderRadius: 2,
              minWidth: 140,
            },
          },
        }}
      >
        <MenuItem
          onClick={(e) => {
            handleMenuClose()
            handleClick('editTitleDialog')(e as unknown as React.MouseEvent<HTMLButtonElement>)
          }}
        >
          <ListItemIcon><EditIcon /></ListItemIcon>
          <ListItemText>Edit</ListItemText>
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleMenuClose()
            shareLink()
            handleShareClick()
          }}
        >
          <ListItemIcon><LinkIcon strokeWidth='1.5' /></ListItemIcon>
          <ListItemText>Share</ListItemText>
        </MenuItem>

        <MenuItem
          onClick={(e) => {
            handleMenuClose()
            handleClick('deleteDialog')(e as unknown as React.MouseEvent<HTMLButtonElement>)
          }}
          sx={{ color: 'error.main' }}
        >
          <ListItemIcon sx={{ color: 'error.main' }}><TrashIcon /></ListItemIcon>
          <ListItemText>Delete</ListItemText>
        </MenuItem>
      </Menu>
      <EditChatTitleDialog
        open={openDialog?.editTitleDialog}
        onClose={() => {
          handleClose('editTitleDialog')
        }}
        historyId={historyId}
        title={title}
      />
      <DeleteConfirmationDialog
        open={openDialog?.deleteDialog}
        title='Are you sure, you want to Delete this Chat ?'
        onConfirm={() => {
          handleClose('deleteDialog')
        }}
        onClose={() => {
          handleClose('deleteDialog')
        }}
        threadIdToDelete={threadId}
      />
    </>
  )
}

export default Actions
